/* lua.js generated code undefined */

require("clover/logic/userTagData/UserTagConst")
let [_, UserTagEvent] = unpack(require("clover/logic/userTagData/UserTagBase"))
UserTagData = xClass("UserTagData")
UserTagEnum = table(
    [1, "ActiveLevel", table(
        [1, "id", 1],
        [1, "name", "activeLevel"],
        [1, "Cls", require("clover/logic/userTagData/ActiveLevelTag")]
    )],
    [1, "SingleLevelHardness", table(
        [1, "id", 2],
        [1, "name", "singleLevelHardness"],
        [1, "Cls", require("clover/logic/userTagData/SingleLevelHardnessTag")]
    )],
    [1, "MultiLevelHardness", table(
        [1, "id", 3],
        [1, "name", "multiLevelHardness"],
        [1, "Cls", require("clover/logic/userTagData/MultiLevelHardnessTag")]
    )],
    [1, "SevenDayPayment", table(
        [1, "id", 4],
        [1, "name", "sevenDayPayment"],
        [1, "Cls", require("clover/logic/userTagData/SevenDayPaymentTag")]
    )],
    [1, "ThirtyDayPayment", table(
        [1, "id", 5],
        [1, "name", "thirtyDayPayment"],
        [1, "Cls", require("clover/logic/userTagData/ThirtyDayPaymentTag")]
    )],
    [1, "AccumulatePayment", table(
        [1, "id", 6],
        [1, "name", "accumulatePayment"],
        [1, "Cls", require("clover/logic/userTagData/AccumulatePaymetTag")]
    )],
    [1, "SevenDayPaymentNew", table(
        [1, "id", 13],
        [1, "name", "sevenDayPaymentNew"],
        [1, "Cls", require("clover/logic/userTagData/SevenDayPaymentTagNew")]
    )],
    [1, "ThirtyDayPaymentNew", table(
        [1, "id", 14],
        [1, "name", "thirtyDayPaymentNew"],
        [1, "Cls", require("clover/logic/userTagData/ThirtyDayPaymentTagNew")]
    )],
    [1, "AccumulatePaymentNew", table(
        [1, "id", 15],
        [1, "name", "accumulatePaymentNew"],
        [1, "Cls", require("clover/logic/userTagData/AccumulatePaymetTagNew")]
    )],
    [1, "ActiveDay", table(
        [1, "id", 16],
        [1, "name", "activeDay"],
        [1, "Cls", require("clover/logic/userTagData/ActiveDayTag")]
    )],
    [1, "FourWeeksPayment", table(
        [1, "id", 17],
        [1, "name", "fourWeeksPayment"],
        [1, "Cls", require("clover/logic/userTagData/FourWeeksPaymentTag")]
    )],
    [1, "LevelArea", table(
        [1, "id", 18],
        [1, "name", "levelArea"],
        [1, "Cls", require("clover/logic/userTagData/LevelAreaTag")]
    )],
    [1, "PersonalDifficulty", table(
        [1, "id", 19],
        [1, "name", "personalDifficulty"],
        [1, "Cls", require("clover/logic/userTagData/PersonalDifficultyTag")]
    )],
    [1, "Active7Day", table(
        [1, "id", 20],
        [1, "name", "active7Day"],
        [1, "Cls", require("clover/logic/userTagData/Active7DayTag")]
    )],
    [1, "Active30Day", table(
        [1, "id", 21],
        [1, "name", "active30Day"],
        [1, "Cls", require("clover/logic/userTagData/Active30DayTag")]
    )]
)
UserTagOnlineEnum = table(
    [0, table([1, "id", 7], [1, "name", "loginFrequency"])],
    [0, table([1, "id", 8], [1, "name", "skill"])],
    [0, table([1, "id", 9], [1, "name", "rmbStyle"])],
    [0, table([1, "id", 10], [1, "name", "cashStyle"])],
    [0, table([1, "id", 11], [1, "name", "androidLogin"])],
    [0, table([1, "id", 12], [1, "name", "iosLogin"])]
)
let tagReverseRef = table()
let instance = null
UserTagData.getInstance = function () {
    let self = this
    if (!instance) {
        instance = UserTagData.new()
    }
    return instance
}
UserTagData.prototype.ctor = function () {
    let self = this
    self.initialized = false
    // for (let k in UserTagEnum) {
    //     let v = UserTagEnum[k]
    //     if ($null(v)) continue
    //     tagReverseRef[v.id] = k
    // }
    // GlobalEventDispatcher.getInstance().addEventListener(kGlobalEvents.kUserLogin, function () {
    //     self.init()
    //     self.readOnlineData()
    // })
}
UserTagData.prototype.parseDropAdjustConfigV2  = function () {
    let self = this
    return CfgManager.load("drop_intervention", "dropadjust_difftag_new").then((data)=>{
        let src = CfgManager.get("drop_intervention");
        let metaRef = DropAdjustPlanV2MetaRef.create()
        metaRef.fromLua(src)
        self.dropAdjustPlanV2 = metaRef
        CfgManager.release("drop_intervention");
        console.log("【掉落配置】 解析后的新配置总表", self.dropAdjustPlanV2)

        // self.dropAdjustDiffTagV2 = table(); 
        let dropadjust_difftag_new_Cfg = CfgManager.get("dropadjust_difftag_new");
        // console.log("【掉落配置】 dropadjust_difftag_new_Cfg", dropadjust_difftag_new_Cfg)
        // for (let _ = 1, cfg = dropadjust_difftag_new_Cfg[1]; cfg; _++, cfg = dropadjust_difftag_new_Cfg[_]) {
        //     let l = $len(self.dropAdjustDiffTagV2);
        //     // console.log("【掉落配置】 _ ", _,l)
        //     let item = {
        //                     "diff_range": cfg.diff_range, 
        //                     "tag_0_formula": cfg.tag_0_formula, 
        //                     "tag_1_formula": cfg.tag_1_formula, 
        //                     "tag_2_formula": cfg.tag_2_formula, 
        //                     "tag_3_formula": cfg.tag_3_formula,
        //                     "tag_4_formula": cfg.tag_4_formula,
        //                     "tag_5_formula": cfg.tag_5_formula
        //                 };
        //     if (l == 0){

        //     }else{
        //         let start0 = self.dropAdjustDiffTagV2[l].start_level;
        //         let end0 = self.dropAdjustDiffTagV2[l].end_level;
        //         let start1 = cfg.start_level;
        //         let end1 = cfg.end_level;
        //         console.log("【掉落配置】 start0 ", start0,start1,end0,end1)

        //         if (start0 == start1 && end0 == end1){
        //             table.insert(self.dropAdjustDiffTagV2[l]["items"], item);
        //             continue;
        //         }
        //     }
        //     table.insert(self.dropAdjustDiffTagV2, cfg);
        //     l = $len(self.dropAdjustDiffTagV2);
        //     self.dropAdjustDiffTagV2[l]["items"] = table();
        //     table.insert(self.dropAdjustDiffTagV2[l]["items"], item);
        // }
        
        let metaRefDropDiffV2 = DropAdjustDiffTagV2MetaRef.create()
        metaRefDropDiffV2.fromLua(dropadjust_difftag_new_Cfg)
        self.dropAdjustDiffTagV2 = metaRefDropDiffV2
        console.log("【掉落配置】 解析后的新难度表", self.dropAdjustDiffTagV2)
        CfgManager.release("dropadjust_difftag_new");
    })

}

UserTagData.prototype.init = function (callback) {
    let self = this
    if (self.initialized) {
        return 
    }
    self.initialized = true;
    // if (__DEBUG){
    //     userLabelData = {
    //         "loginNum": 1,
    //         "payNum": 0
    //     }
    // }
    //在UserManager的initUserLabel赋值
    self.userLabelData = UserManager.getInstance().userLabel || {};
    self.dropAdjustGroup = null; // 包含testGroup和testId
    // self["personalDifficulty"] = require("clover/logic/userTagData/PersonalDifficultyTag").new();
    // self["active7Day"] = require("clover/logic/userTagData/Active7DayTag").new();
    console.log("UserTagEnum ",UserTagEnum)
    for (const key in UserTagEnum) {
        if(UserTagEnum[key].id >= 19){
            self[UserTagEnum[key].name] = UserTagEnum[key].Cls.new()
        }
    }

    self.DASchemeConfig = null; // 解析后的DASchemeConfig

    return CfgManager.load("dropadjust_apply", "dropadjust", "dropadjust_difftag", "dropadjust_orthgroup", "dropadjust_orthapply").then((data) => {
        console.log("!!!! UserTagData load config success", data);
        self.applyConfig = CfgManager.get("dropadjust_apply");  // 掉落优化应用
        for (const k in self.applyConfig) {
            if (self.applyConfig[k].testGroup){
                self.applyConfig[k].testGroup = self.applyConfig[k].testGroup.split(";");
            }
        }
        self.dropAdjustConfig = CfgManager.get("dropadjust");  // 掉落优化配置
        self.DASchemeConfig = MetaManager.getInstance().drop_adjust;
        let metaRef = DropAdjustMetaRef.create()
        console.log("【掉落配置】 掉落优化配置表dropAdjustConfig ", self.dropAdjustConfig)
        metaRef.fromLua(self.dropAdjustConfig)
        self.dropAdjustmMetaRef = metaRef
        // console.log("【掉落配置】 解析后掉落优化配置表metaRef", metaRef)

        self.DASchemeConfig = metaRef.DASchemeConfig
        console.log("DASchemeConfig", self.DASchemeConfig)
        self.difftagConfig = table();  // 掉落优化难度标签条件
        let temp = CfgManager.get("dropadjust_difftag");
        // console.log("【掉落配置】 旧难度配置表", temp)
        // for (let _ = 1, cfg = temp[1]; cfg; _++, cfg = temp[_]) {
        //     let l = $len(self.difftagConfig);
        //     let item = {
        //                     "diff_range": cfg.diff_range, 
        //                     "tag_0_formula": cfg.tag_0_formula, 
        //                     "tag_1_formula": cfg.tag_1_formula, 
        //                     "tag_2_formula": cfg.tag_2_formula, 
        //                     "tag_3_formula": cfg.tag_3_formula
        //                 };
        //     if (l == 0){

        //     }else{
        //         let start0 = self.difftagConfig[l].start_level;
        //         let end0 = self.difftagConfig[l].end_level;
        //         let start1 = cfg.start_level;
        //         let end1 = cfg.end_level;
        //         console.log("【掉落配置】 start0 ", start0,start1,end0,end1)

        //         if (start0 == start1 && end0 == end1){
        //             table.insert(self.difftagConfig[l]["items"], item);
        //             continue;
        //         }
        //     }
        //     table.insert(self.difftagConfig, cfg);
        //     l = $len(self.difftagConfig);
        //     self.difftagConfig[l]["items"] = table();
        //     table.insert(self.difftagConfig[l]["items"], item);
        // }
        let metaRefDropDiffV1 = DropAdjustDiffTagMetaRef.create()
        metaRefDropDiffV1.fromLua(temp)
        self.difftagConfig = metaRefDropDiffV1
        console.log("【掉落配置】 旧 self.difftagConfig", self.difftagConfig)
        
        self.orthgroupConfig = CfgManager.get("dropadjust_orthgroup");  // 正交分组配置
        for (const k in self.orthgroupConfig) {
            self.orthgroupConfig[k].testGroupStr = self.orthgroupConfig[k].testGroup;
            if (self.orthgroupConfig[k].testGroup){
                let d1 = self.orthgroupConfig[k].testGroup.split(";");
                for (const k2 in d1) {
                    let d2 = d1[k2].split("_");
                    d1[k2] = {};
                    d1[k2]["group"] = d2[0];
                    d1[k2]["weight"] = tonumber(d2[1]);
                    d1[k2]["strategyStr"] = d2[2];
                }
                self.orthgroupConfig[k].testGroup = d1;
            }
        }
        self.orthapplyConfig = CfgManager.get("dropadjust_orthapply");  // 正交策略配置

        CfgManager.release("dropadjust_apply");
        CfgManager.release("dropadjust");
        CfgManager.release("dropadjust_difftag");
        CfgManager.release("dropadjust_orthgroup");
        CfgManager.release("dropadjust_orthapply");

        // 掉落优化正交分组打点
        OrthGroupHelper.getInstance().dcOrthGroupAfterLogin();
    })


    // let tagMeta = MetaManager.getInstance().getLabels()
    // let [tmp, config] = [table(), table()]
    // for (let k in UserTagEnum) {
    //     let v = UserTagEnum[k]
    //     if ($null(v)) continue
    //     tmp[v.id] = v
    // }
    // let $st15 = tagMeta || table()
    // for (let l in $st15) {
    //     let w = $st15[l]
    //     if ($null(w)) continue
    //     if (tmp[w.type]) {
    //         let name = tmp[w.type].name
    //         config[name] = config[name] || table([1, "config", table()])
    //         config[name].config[w.label] = table([1, "min", w.min], [1, "max", w.max])
    //     }
    // }
    // for (let k in UserTagEnum) {
    //     let v = UserTagEnum[k]
    //     if ($null(v)) continue
    //     let name = v.name
    //     self[name] = v.Cls.new()
    //     if (config[name]) {
    //         self[name].refresh(config[name])
    //     }
    //     self[name].on(UserTagEvent.StoreData, handler(self, self.writeToFile))
    // }
    // instance.readFromFile()
}

/**
 * startLevel的时候获得
 * @param {*} payNum 过去28天累积付费金额
 * @param {*} pDiff 关卡个人难度
 * @param {*} nDiff 关卡自然难度
 * @param {*} levelPersonDiff 20关卡自然难度
 * @param {*} levelNatureDiff 20关卡自然难度
 * @param {*} targetComplete 关卡结束时目标物计数的平均值
 * @param {*} except 目标期望完成度（步数:已完成目标,步数:已完成目标,步数:已完成目标）
 */
UserTagData.prototype.refreshOrthByStartLevel = function(payNum, pDiff = 0, nDiff = 0, except = 0, levelPersonDiff = [], levelNatureDiff = [], targetComplete){
    let self = this;
    if (self.userLabelData){
        self.userLabelData.payNum = payNum;
        self.userLabelData.pDiff = pDiff;
        self.userLabelData.nDiff = nDiff;
        self.userLabelData.levelPersonDiff = levelPersonDiff;
        self.userLabelData.levelNatureDiff = levelNatureDiff
        self.userLabelData.except = DAManager.getInstance().parseCompleteExpect(except);
        self.userLabelData.targetComplete = targetComplete
        UserManager.getInstance().userLabel = self.userLabelData;
    }
}

UserTagData.prototype.getLevelFailCount = function (levelId) {
    let self = this
    // body
    let record = self.singleLevelHardness && self.singleLevelHardness.record
    if (record && record[levelId]) {
        return record[levelId]
    }
    return 0
}
UserTagData.prototype.setDebugTag = function (tag, value) {
    // let self = this
    // self.init()
    // cc.log(tag, value, tagReverseRef[tag], UserTagEnum[tagReverseRef[tag] || 0])
    // let tag = UserTagEnum[tagReverseRef[tag] || 0]
    // if (!tag) {
    //     return 
    // }
    // if (value === 255) {
    //     self[tag.name].__debugTagValue = null
    // } else {
    //     self[tag.name].__debugTagValue = value
    // }
}
UserTagData.prototype.getTag = function (tag) {
    let __VA_ARG = $slice(arguments, 1)
    let self = this
    self.init()

    if (self[tag.name] && self[tag.name].__debugTagValue) {
        return tag.id * UserTagConst.TagInterval + self[tag.name].__debugTagValue
    } else if (tag.id >= 13 && tag.id <= 21) {
        // WARN: maybe multi result
        return self[tag.name].getTag(...__VA_ARG)
    } else if (self[tag.name] && type(self[tag.name].getTag) === "function") {
        return tag.id * UserTagConst.TagInterval + self[tag.name].getTag(...__VA_ARG)
    }
    return 0
}
UserTagData.prototype.getIsTag = function (value) {
    let self = this
    let id = Math.floor(value / UserTagConst.TagInterval)
    let tag = tagReverseRef[id]
    if (!tag) {
        return false
    } else {
        return self.getTag(UserTagEnum[tag]) === value
    }
}
UserTagData.prototype.readOnlineData = function () {
    let self = this
    let result = table()
    let data = UserManager.getInstance().getUserTagData()
    for (let k in UserTagEnum) {
        let v = UserTagEnum[k]
        if ($null(v)) continue
        if (type(self[v.name].convertOnlineRecord) === "function") {
            result[v.name] = self[v.name].convertOnlineRecord(data)
        }
    }
    let $st34 = (data || table()).config || table()
    for (let i = 1, v = $st34[1]; v; i++, v = $st34[i]) {
        let obj = table.find(UserTagEnum, function (value) {
            return value.id === v.type
        })
        if (obj) {
            result[obj.name] = result[obj.name] || table([1, "config", table()])
            result[obj.name].config = result[obj.name].config || table()
            result[obj.name].config[v.label] = table([1, "min", v.min], [1, "max", v.max])
        }
    }
    for (let k in UserTagEnum) {
        let v = UserTagEnum[k]
        if ($null(v)) continue
        let name = v.name
        if (self[name] && type(self[name].refresh) === "function") {
            self[name].refresh(result[name] || table())
        }
    }
    self.writeToFile()
}
UserTagData.prototype.readFromFile = function () {
    let self = this
    let data = Persistence.readFileData(LocalDataFiles.kUserTagInfo) || table()
    for (let k in UserTagEnum) {
        let v = UserTagEnum[k]
        if ($null(v)) continue
        let name = v.name
        if (self[name] && type(self[name].refresh) === "function") {
            self[name].refresh(data[name] || table())
        }
    }
}
UserTagData.prototype.writeToFile = function () {
    let self = this
    let data = table()
    for (let k in UserTagEnum) {
        let v = UserTagEnum[k]
        if ($null(v)) continue
        let name = v.name
        if (self[name] && type(self[name].encode) === "function") {
            data[name] = self[name].encode()
        }
    }
    Persistence.writeFileData(data, LocalDataFiles.kUserTagInfo)
}
UserTagData.prototype.showDebugInfo = function () {
    let self = this
    let data = table()
    for (let k in UserTagEnum) {
        let v = UserTagEnum[k]
        if ($null(v)) continue
        let name = v.name
        if (self[name] && type(self[name].encode) === "function") {
            data[name] = self[name].encode()
        }
    }
    return data
}
UserTagData.prototype.getDCData = function () {
    let self = this
    let data = table()
    for (let k in UserTagEnum) {
        let v = UserTagEnum[k]
        if ($null(v)) continue
        data[v.id] = self.getTag(v)
    }
    return data
}
UserTagData.getInstance()
